import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { ISearchResultTitleProps } from './interfaces';
import theme from '@src/theme/theme';

const SearchTitle: React.FC<ISearchResultTitleProps> = ({ title, value }) => {
  return (
    <Flex align="center" justify="center" my={8}>
      <Text
        as="h1"
        fontFamily={theme.fonts.montserrat}
        fontWeight="300"
        align="center"
        color="grey.300"
        fontSize="32px"
        my={0}
        px={4}
      >
        {title} {value}
      </Text>
    </Flex>
  );
};

export default SearchTitle;
